import { css, styled } from '@mui/material';

const StyledPageTitle = styled('div')(
  ({ theme }) => css`
    margin-bottom: ${theme.spacing('1XL')};
    color: ${theme.palette.main.professional_blue};
    word-break: break-word;
  `
);

export default StyledPageTitle;
